import ReportsApi from '../../apis/Reports';
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        purchases: [],
        file_purchases: null,
        purchase: null,
        detail: [],
        file_purchases_detail: null,
        file_name: null,
        filters: {
          company_id: null,
          supplier_id: null,
          date_from: moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD"),
          date_until: moment().format("YYYY-MM-DD"),
          product_id: null,
          type_document: null,
          document: null
        },
        paginated:{},
        optionsAux: {
            page: 1,
            itemsPerPage: 10
        }
    },
    mutations: {
        set_purchases (state, data) {
            state.purchases = data;
        },
        set_file_purchases (state, value) {
            state.file_purchases = value;
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_purchase (state, data) {
            state.purchase = data;
        },
        set_detail (state, data) {
            state.detail = data;
        },
        set_file_purchases_detail (state, value) {
            state.file_purchases_detail = value;
        },
        set_file_name (state, value) {
            state.file_name = value;
        },
        set_optionsAux (state, data) {
            state.optionsAux =  data
        },
        set_paginated (state, data) {
            state.paginated =  data
        },
    },
    actions: {
        setPurchases ({commit}, data) {
            commit('set_purchases', data);
        },
        emptyFilePurchases ({commit}) {
            commit('set_file_purchases', null);
        },
        emptyFilePurchaseDetail ({commit}) {
            commit('set_file_purchases_detail', null);
        },
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        selectPurchase ({commit}, data) {
            commit('set_purchase', data);
        },
        setOptionsAux({commit}, value) {
            commit('set_optionsAux', value);
        },
        setPaginated ({commit}, value) {
            commit('set_paginated', value);
        },
        async getPurchases({commit, dispatch}, filters) {
            commit('set_purchases', []);
            return await ReportsApi.getPurchases(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data, data: []})
                            commit('set_purchases', response.data.data || []);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar compras, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getPurchasesDetail({commit, dispatch}, purchase) {
            commit('set_detail', []);
            return await ReportsApi.getPurchasesDetail(purchase)
                        .then( response => {
                            commit('set_detail', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar detalle de compra, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async purchasesExcel({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ReportsApi.purchasesExcel(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de compras, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async purchaseDetailExcel({commit, dispatch}, purchase) {
            commit('set_file_purchases_detail', null);
            return await ReportsApi.detailExcel(purchase)
                        .then( response => {
                            commit('set_file_purchases_detail', response.data.file_purchases_detail);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de compra, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
    }
}